import { NumberGrid } from '@Animation/mechanics/base/number-grid'
import { NumberSelector } from '@Animation/mechanics/base/number-selector'
import { LIGHT_THREE_ATLAS_FRAMES, LIGHT_THREE_TEXTURE_KEYS } from '.'
import { tweenPromise } from '@Animation/utils'

export class LightThreeNumberSelector extends NumberSelector {
  flashVertical: Phaser.GameObjects.Image
  flashHorizontal: Phaser.GameObjects.Image

  constructor(
    scene: Phaser.Scene,
    numberGrid: NumberGrid,
    miniGameSelections: number[],
    preNumberSelected: (index: number) => Promise<void>,
    onNumberSelected: (number: number) => void,
  ) {
    super(scene, numberGrid, miniGameSelections, preNumberSelected, onNumberSelected)

    this.flashHorizontal = scene.add.image(
      0,
      0,
      LIGHT_THREE_TEXTURE_KEYS.ATLAS,
      LIGHT_THREE_ATLAS_FRAMES.FLASH_HORIZONTAL,
    )
    this.flashVertical = scene.add.image(
      0,
      0,
      LIGHT_THREE_TEXTURE_KEYS.ATLAS,
      LIGHT_THREE_ATLAS_FRAMES.FLASH_VERTICAL,
    )
    this.flashHorizontal.setOrigin(0, 0.5)
    this.flashHorizontal.setScale(0.5)
    this.flashHorizontal.setVisible(false)
    this.flashVertical.setOrigin(0.5, 1)
    this.flashVertical.setVisible(false)
    this.flashVertical.setScale(0.5)

    this.add(this.flashHorizontal)
    this.add(this.flashVertical)
  }

  async skip(numbers: number[]) {
    super.skip(numbers)
    this.flashHorizontal.setVisible(false)
    this.flashVertical.setVisible(false)
  }

  async targetSingleNumber(number: number): Promise<void> {
    const targetX = this.numberGrid.x + this.numberGrid.numbers[number - 1].x
    const targetY = this.numberGrid.y + this.numberGrid.numbers[number - 1].y

    const startOffset = 1000
    const sizeOffset = this.numberGrid.xPadding
    const duration = 1500

    this.flashVertical.setX(targetX)
    this.flashVertical.setY(targetY - startOffset)
    this.flashVertical.setVisible(true)

    this.flashHorizontal.setX(targetX + startOffset)
    this.flashHorizontal.setY(targetY)
    this.flashHorizontal.setVisible(true)

    const horizontalPromise1 = tweenPromise(this.scene, {
      targets: this.flashHorizontal,
      duration: duration / 2,
      x: targetX - sizeOffset,
    })

    const horizontalPromise2 = tweenPromise(this.scene, {
      targets: this.flashHorizontal,
      duration: duration / 2,
      x: targetX - sizeOffset - startOffset,
    })

    const verticalPromise1 = tweenPromise(this.scene, {
      targets: this.flashVertical,
      duration: duration / 2,
      y: targetY + sizeOffset,
    })

    const verticalPromise2 = tweenPromise(this.scene, {
      targets: this.flashVertical,
      duration: duration / 2,
      y: targetY + sizeOffset + startOffset,
    })

    await Promise.all([horizontalPromise1(), verticalPromise1()])
    const selectNumber = this.numberGrid.selectNumber(number)
    await Promise.all([horizontalPromise2(), verticalPromise2(), selectNumber])
  }
}
